<template>
  <div class="project-param-settings app-panel" v-loading="pageLoading">
    <div class="app-title mb">参数设置</div>
    <el-form :label-width="labelWidth">
      <el-form-item label="重复识别间隔">
        <p>{{valueOne}}<i class="el-icon-edit-outline" @click="dialogOne.show = true"></i></p>
      </el-form-item>
      <el-form-item label="员工自动检测">
        <p>{{valueThree ? valueTwo : '关闭'}}<i class="el-icon-edit-outline" @click="dialogTwo.show = true"></i></p>
      </el-form-item>
      <el-form-item label="风控日报提醒">
        <p>{{valueFour}}<i class="el-icon-edit-outline" @click="dialogThree.show = true"></i></p>
        <!-- <p>{{valueThree ? valueTwo : '关闭'}}<i class="el-icon-edit-outline" @click="dialogTwo.show = true"></i></p> -->
      </el-form-item>
      <el-form-item label="设备故障提醒">
        <p>{{valueFive}}<i class="el-icon-edit-outline" @click="dialogFour.show = true"></i></p>
        <!-- <p>{{valueThree ? valueTwo : '关闭'}}<i class="el-icon-edit-outline" @click="dialogTwo.show = true"></i></p> -->
      </el-form-item>
    </el-form>
    <el-dialog title="修改重复识别间隔" :visible.sync="dialogOne.show" center :width="dialogWidth" append-to-body>
      <el-form>
        <el-form-item>
          <el-select v-model="formOne.value" placeholder="请选择">
            <el-option v-for="(value, index) in timeOptions" :key="index" :label="value.label" :value="value.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="submitOne">确定</el-button>
        <el-button @click="dialogOne.show = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="员工自动检测" :visible.sync="dialogTwo.show" center :width="dialogWidth" append-to-body>
      <el-form>
        <el-form-item>
          <el-radio-group v-model="formTwo.value">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <p>判断条件</p>
          <p>客户到访频次超过<el-input class="formTwo-input" v-model="formTwo.time"></el-input>天</p>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="submitTwo">确定</el-button>
        <el-button @click="dialogTwo.show = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="风控日报提醒" :visible.sync="dialogThree.show" center :width="dialogWidth" append-to-body>
      <el-form>
        <el-form-item>
          <el-select multiple v-model="formThree.value" placeholder="请选择" reserve-keyword filterable remote :remote-method="initPeopleOptionsOne" :loading="peopleLoadingOne">
            <el-option v-for="value in peopleOptionsOne" :key="`${value.name}(${value.mobile})`" :label="`${value.name}(${value.mobile})`" :value="value.userid"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="submitThree">确定</el-button>
        <el-button @click="dialogThree.show = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="设备故障提醒" :visible.sync="dialogFour.show" center :width="dialogWidth" append-to-body>
      <el-form>
        <el-form-item>
          <el-select multiple v-model="formFour.value" placeholder="请选择" reserve-keyword filterable remote :remote-method="initPeopleOptionsTwo" :loading="peopleLoadingTwo">
            <el-option v-for="value in peopleOptionsTwo" :key="`${value.name}(${value.mobile})`" :label="`${value.name}(${value.mobile})`" :value="value.userid"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="submitFour">确定</el-button>
        <el-button @click="dialogFour.show = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import ProjectService from '@/io/project.js';
  import CommonService from '@/io/common.js';

  export default {
    name: 'ProjectParamSettings',
    data() {
      return {
        pageLoading: false,
        id: this.$route.params.id,
        valueOne: '',
        valueTwo: '',
        valueThree: '',
        valueFour: '',
        valueFive: '',
        dialogOne: {
          show: false
        },
        formOne: {
          value: ''
        },
        dialogTwo: {
          show: false
        },
        formTwo: {
          value: 1,
          time: ''
        },
        dialogThree: {
          show: false
        },
        formThree: {
          value: []
        },
        dialogFour: {
          show: false
        },
        formFour: {
          value: []
        },
        timeOptions: [],
        peopleOptionsOne: [],
        peopleLoadingOne: false,
        peopleOptionsTwo: [],
        peopleLoadingTwo: false,
      }
    },
    mounted() {
      this.initOptions().then(() => {
        this.initPage();
      });
    },
    methods: {
      initPage() {
        this.pageLoading = true;
        return ProjectService.paramInfo(this.id).then(res => {
          this.valueOne = res.data.project_config_face_recognition_step_time_transform;
          this.valueTwo = `${res.data.project_config_external_staff_recognition_visit_days_times}天`;
          this.valueThree = res.data.project_config_external_staff_recognition_enable;
          this.valueFour = res.data.project_config_risk_report_daily_recieve_user_ids.map(val => `${val.name}(${val.mobile})`).join('、');
          this.valueFive = res.data.project_config_alarm_wechat_user_ids.map(val => `${val.name}(${val.mobile})`).join('、');
          this.formOne.value = res.data.project_config_face_recognition_step_time;
          this.formTwo.value = res.data.project_config_external_staff_recognition_enable;
          this.formTwo.time = res.data.project_config_external_staff_recognition_visit_days_times;
          this.formThree.value = res.data.project_config_risk_report_daily_recieve_user_ids.map(val => val.userid);
          this.formFour.value = res.data.project_config_alarm_wechat_user_ids.map(val => val.userid);
          this.peopleOptionsOne = res.data.project_config_risk_report_daily_recieve_user_ids;
          this.peopleOptionsTwo = res.data.project_config_alarm_wechat_user_ids;
        }).catch(() => {}).finally(() => {
          this.pageLoading = false;
        });
      },
      initOptions() {
        return ProjectService.paramSettingsInfo().then(res => {
          this.timeOptions = res.data.recognition_step_time;
        }).catch(() => {});
      },
      initPeopleOptionsOne(query) {
        if (query) {
          this.peopleLoadingOne = true;
          return CommonService.peopleList(query).then(res => {
            this.peopleOptionsOne = res.data;
          }).catch(() => {}).finally(() => {
            this.peopleLoadingOne = false;
          });
        }
      },
      initPeopleOptionsTwo(query) {
        if (query) {
          this.peopleLoadingTwo = true;
          return CommonService.peopleList(query).then(res => {
            this.peopleOptionsTwo = res.data;
          }).catch(() => {}).finally(() => {
            this.peopleLoadingTwo = false;
          });
        }
      },
      submitOne() {
        ProjectService.paramTimeSettings(this.id, this.formOne.value).then(() => {
          this.initPage();
        }).catch(() => {}).finally(() => {
          this.dialogOne.show = false;
          this.$message.success('编辑成功');
        });
      },
      submitTwo() {
        ProjectService.paramAutoDetectSettings(this.id, this.formTwo.value, this.formTwo.time).then(() => {
          this.initPage();
        }).catch(() => {}).finally(() => {
          this.dialogTwo.show = false;
          this.$message.success('编辑成功');
        });
      },
      submitThree() {
        ProjectService.paramRiskSettings(this.id, this.formThree.value).then(() => {
          this.initPage();
        }).catch(() => {}).finally(() => {
          this.dialogThree.show = false;
          this.$message.success('编辑成功');
        });
      },
      submitFour() {
        ProjectService.paramDeviceBrokenSettings(this.id, this.formFour.value).then(() => {
          this.initPage();
        }).catch(() => {}).finally(() => {
          this.dialogFour.show = false;
          this.$message.success('编辑成功');
        });
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .project-param-settings {
    .el-form {
      .el-form-item {
        .el-icon-edit-outline {
          color: @color-primary;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
  .formTwo-input {
    width: 100px;
    margin: 0 10px;
  }
</style>